module.exports = __webpack_public_path__ + "static/media/splash_manatee.52f01208.png";